import { restClient } from '@/Core'

export const SendAssignmentPushTask = async (taskUuid: string, message: string): Promise<void> => {
    await restClient.post(`/services/executor-assignments/${taskUuid}/send-push`, { json: { message } })
}
